<template>
  <div class="main-content">
    <breadcrumb :nameSection="nameSection" :listRoutes="listRoutes"></breadcrumb>
    <div class="form-content pt-4">
      <div class="row d-flex justify-content-between px-3">
        <h2 class="form-title-principal form-title">Cotizaciones</h2>
      </div>
      <div class="table-orders">
        <table class="table">
          <thead>
            <tr>
              <th>Link cotizado</th>
              <th style="min-width: 180px">Estado</th>
              <th>ID de la orden</th>
              <th>ID del usuario</th>
              <th>Store</th>
              <th>Fecha</th>
            </tr>
          </thead>
          <tbody>

            <tr v-for="data in cotizaciones" :key="data">
              <td>
                <a class="line-clamp-2" v-if="data.url === 'vacío'">
                  Precio : {{ data.price }} <br />
                  Peso : {{ data.weight }}
                </a>
                <a class="line-clamp-2 link" target="_blank" :href="data.url" v-else>
                  {{ data.url }}
                </a>
              </td>
              <td style="min-width: 180px">
                <p class="user">
                  {{ data.id_order ? "Convertido en Orden" : "Simple cotización" }}
                </p>
              </td>
              <td>
                {{ data.id_order }}
              </td>
              <td>
                <router-link
                  :to="{
                    name: 'UserDetail',
                    params: { idUser: data.idUsuario },
                  }"
                  target="_Blank"
                >
                  {{ data.idUsuario }}</router-link
                >
              </td>
              <td>
                <span v-if="data.idStore === 1">SENDI</span>
                <span v-else-if="data.idStore === 2">ENVIOS</span>
                <span v-else-if="data.idStore === null">
                  {{ data.id_order }}
                </span>
              </td>
              <td>{{ data.created_at }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination
      :pagination="pagination"
      @changePagination="getPurchaseOrdersByPage"
      v-if="is_loading == false"
    >
    </pagination>
  </div>
</template>
<style>
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.link {
  color: #1f5ee7 !important;
  text-decoration: underline;
}

.user {
  font-weight: 600;
  margin: 0;
  padding: 0;
}
</style>
<script>
import breadcrumb from "@/components/prefab/structures/breadcrumb.vue";
import Pagination from "./Pagination.vue";
import axios from "axios";
export default {
  components: { breadcrumb, Pagination },
  created() {},
  data() {
    return {
      cotizaciones: null,
      nameSection: "Cotizaciones",
      listRoutes: [{ nameRoute: "cotizaciones", titleRoute: "Cotizaciones de producto" }],
      tableData: {
        orderBy: "created_at",
        length: 10,
        page: 1,
      },
      pagination: {
        lastPage: "5",
        currentPage: 1,
        total: 5,
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "1",
        to: "5",
      },
      is_loading: true,
    };
  },
  created() {
    this.getPurchaseOrdersByPage();
  },
  methods: {
    getPurchaseOrdersByPage(page) {
      this.is_loading = true;
      //   this.tableData.draw++;
      this.tableData.page = page;

      let url = process.env.API_URL + "/api/quoatation/list";

      // eslint-disable-next-line no-unreachable
      axios
        .get(url, { params: this.tableData })
        .then((response) => {
          console.log(response, "cotizacion");
          this.cotizaciones = response.data.body.data;
          this.is_loading = false;
          this.configPagination(response.data.body);
        })
        .catch((error) => {
          console.log(error, "error de la cotización");
          alert("No se obtuvieron resultados");
          this.is_loading = false;
          return;
        });
    },
    configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last;
      this.pagination.nextPageUrl = data.next;
      this.pagination.prevPageUrl = data.prev;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.perPage = this.tableData.length;
    },
  },
};
</script>



// WEBPACK FOOTER //
// Cotizaciones.vue?58518c18